import { getSubtotalDiscountAmount } from '../../../../../../../../../shared/design-system/components/molecules/upgrade-plan-billing-section/helper/helper';

export const getTotalAmountForOutreachPlan = ({
  totalAmount,
  discountType,
  discount,
  sendGetInboxAnalyzerCalculatePayResponse,
}) => {
  let subTotal = totalAmount;

  if (sendGetInboxAnalyzerCalculatePayResponse) {
    subTotal = sendGetInboxAnalyzerCalculatePayResponse?.amountToPay;
  }

  const discountedAmount = getSubtotalDiscountAmount(
    discountType,
    sendGetInboxAnalyzerCalculatePayResponse?.amountToPay || totalAmount,
    discount,
  );

  if (discountedAmount) {
    return (subTotal - discountedAmount).toFixed(2);
  }

  return subTotal.toFixed(2);
};

export const isPlan = (planId) => planId >= 517;
